/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, February 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");


module.exports = Model({
	name: "activeownformprepopulate",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,
});

function init() {
	this.push(null);
}

function uninit() {
	this.push(null);
}

function listeners() {
	return {
		"activeownformsubmission:trigger:creating": handleCreating,
		"activeownformsubmission:cancelled": handleReset,
		"activeownformsubmission:finished": handleReset
	};
}

function triggers() {
	return {
	};
}

function handleReset() {
	this.push(null);
}

function handleCreating(data) {
	var formId = data.id;

	if (!formId) return;

	this.emit("save:trigger:start");

	if(data.mode !== "silence") {
		this.emit("usermetrics:trigger:track", "create own prepopulated form submission", {
			formId: formId
		});
	}

	return this.api.forms.submission.group.own.prepopulate(formId)
		.then(handle_load.bind(this)).catch(finish_load);

}

function handle_load(data) {

	this.push(data);
	this.emit("save:trigger:finish");

}

function finish_load(err) {

	console.error(err);
	this.push({});
	this.emit("save:trigger:finish");

}